import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import Alert from "@mui/material/Alert";
import { DebugColor, DebugPopoverInner, } from "@plansoft-configuration-renderer/debug";
export function LayoutError({ layoutNode, children, }) {
    const layoutNodeId = layoutNode.id;
    return (_jsx(Alert, { severity: "error", action: _jsx(DebugPopoverInner, { src: layoutNode, title: "Details", id: layoutNodeId, color: DebugColor.Error }), children: _jsx(_Fragment, { children: children }) }));
}
//# sourceMappingURL=LayoutError.js.map